import { HTMLAttributes } from "react";

export default function Supabase(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2205_3857)">
        <path
          d="M27.2945 43.5145C26.2713 44.8211 24.1969 44.1052 24.1722 42.4369L23.8117 18.036H39.9913C42.9218 18.036 44.5562 21.4684 42.734 23.7959L27.2945 43.5145Z"
          fill="url(#paint0_linear_2205_3857)"
        />
        <path
          d="M27.2945 43.5145C26.2713 44.8211 24.1969 44.1052 24.1722 42.4369L23.8117 18.036H39.9913C42.9218 18.036 44.5562 21.4684 42.734 23.7959L27.2945 43.5145Z"
          fill="url(#paint1_linear_2205_3857)"
          fillOpacity="0.2"
        />
        <path
          d="M20.7143 4.25144C21.7375 2.94473 23.812 3.66071 23.8366 5.32904L23.9946 29.7299H8.01756C5.08693 29.7299 3.45246 26.2975 5.27481 23.9701L20.7143 4.25144Z"
          fill="#3ECF8E"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2205_3857"
          x1="23.8117"
          y1="23.4463"
          x2="38.251"
          y2="29.4181"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#249361" />
          <stop offset="1" stopColor="#3ECF8E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2205_3857"
          x1="17.4365"
          y1="14.5947"
          x2="24.1384"
          y2="27.0357"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_2205_3857">
          <rect
            width="39"
            height="41"
            fill="white"
            transform="translate(4.5 3.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
